document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('.seg-mobile-drawer');
  const openButton = document.querySelector('[data-seg-menu-open]');
  const closeButton = document.querySelector('[data-seg-menu-close]');

  if (drawer && openButton) {
    openButton.addEventListener('click', () => drawer.setAttribute('open', ''));
  }
  if (drawer && closeButton) {
    closeButton.addEventListener('click', () => drawer.removeAttribute('open'));
  }
  if (drawer) {
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer.querySelector(':scope > summary')) drawer.removeAttribute('open');
      if (event.target.closest('a')) drawer.removeAttribute('open');
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') drawer.removeAttribute('open');
    });
  }
});

// Exposes CTA interactions for a future analytics implementation without loading one.
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-seg-track]');
  if (!link || !Array.isArray(window.dataLayer)) return;

  window.dataLayer.push({
    event: 'segitec_cta_click',
    cta_name: link.dataset.segTrack || '',
    service_handle: link.dataset.segService || '',
    cta_location: link.dataset.segLocation || '',
    destination: link.href || ''
  });
});
